import React from 'react'

class Logo extends React.Component {
  state = {
    error: false,
  }

  componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.setState({ error: false })
    }
  }

  render() {
    return this.state.error ? (
      <div className={this.props.className}>{this.props.name}</div>
    ) : (
      <img
        className={this.props.className}
        src={`/logos/${this.props.name}.png`}
        alt={this.props.name}
        onError={() => this.setState({ error: true })}
      />
    )
  }
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo.js